import { ReactNode } from 'react';

type Props = {
  heading?: string;
  items?: string[] | ReactNode[];
  numberColor?: string;
};

export default function NumberedList({ numberColor = '$color-green', heading, items = [] }: Props) {
  return (
    <div className="numbered-list">
      {heading && <h3>{heading}</h3>}
      <ol>
        {items.map((item, index) => (
          <li key={`number${item}`}>
            <div className="numbered-list__item__number" style={{ color: numberColor }}>
              {`${index + 1}. `}
            </div>
            <div className="numbered-list__item__text">
              {item}
            </div>
          </li>
        ))
        }
      </ol>
    </div>
  );
}
